import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Drinks Conversations Statistics
export const getDrinksConversationsStatistics = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/statistics/drinks/conversation", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        message: "تم جلب البيانات بنجاح",
        data: [
          {
            id,
            user_id,
            messages: [],
            questions_count,
            status,
            ai_drink_id,
            created_at,
            updated_at,
            drink,
            user
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

// ✅ Get Materials Usage Statistics (Admin)
export const getMaterialsUsageStatistics = async (filters = {}) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const body = {
    ...(filters?.from_date ? { from_date: filters.from_date } : {}),
    ...(filters?.to_date ? { to_date: filters.to_date } : {}),
    ...(filters?.date ? { date: filters.date } : {}),
  };

  try {
    const res = await api.post(
      "/admin/statistics/material/usage",
      body,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    const totalUsage = Array.isArray(res?.data?.data?.total_usage)
      ? res.data.data.total_usage
      : Array.isArray(res?.data?.data)
        ? res.data.data
        : [];

    return {
      ...res.data,
      data: totalUsage,
    };
    /*
      expected:
      {
        message: "تم جلب البيانات بنجاح",
        data: {
          total_usage: [
            {
              material_id,
              material_name,
              total_used,
              unit,
              drinks: [
                {
                  drink_id,
                  drink_name,
                  amount_used
                }
              ]
            }
          ]
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};